import apiFetch from '../../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `RegistroAlimentacion/imprimirRegistroAlimentacion`, method: 'POST', body: values, token: token})
}